var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconoCategoriesInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    width: 27,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#999999;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.7,3.3v3.9h-3.9V3.3H16.7 M7.1,3.3v3.9H3.3V3.3H7.1 M16.7,12.9v3.9h-3.9v-3.9H16.7 M7.1,12.9v3.9H3.3v-3.9 H7.1 M18,2h-6.4v6.4H18V2L18,2z M8.4,2H2v6.4h6.4V2L8.4,2z M18,11.6h-6.4V18H18V11.6L18,11.6z M8.4,11.6H2V18h6.4V11.6L8.4,11.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoCategoriesInactive);
export default __webpack_public_path__ + "static/media/icono_categories_inactive.173b47b40ebb41fda4c177ae5dd84742.svg";
export { ForwardRef as ReactComponent };